<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <g>
    <path class="cls-1" d="m36.47,11.61c2.6.85,5.05,3.89,5.05,7.12v6.39s28.33,0,28.33,0h3.11s0-6.39,0-6.39c0-3.92-1.43-7.25-6.25-7.12h-3.8s-24.17,0-24.17,0h-2.27Z"/>
    <path class="cls-2" d="m72.95,26.86h-31.44c-.96,0-1.73-.78-1.73-1.73v-6.39c0-2.52-1.99-4.87-3.86-5.48-.81-.27-1.3-1.08-1.17-1.92.13-.84.86-1.46,1.71-1.46h30.24c2.32-.06,4.23.59,5.62,1.94,1.57,1.53,2.36,3.85,2.36,6.92v6.39c0,.96-.78,1.73-1.73,1.73Zm-29.7-3.47h27.97v-4.66c0-1.44-.23-3.38-1.31-4.44-.7-.68-1.73-.99-3.15-.95h-25.33c1.13,1.58,1.82,3.5,1.82,5.39v4.66Z"/>
  </g>
  <g>
    <path class="cls-1" d="m33.77,11.61h29.66c.53,0,.96.43.96.96v55.33c0,5.83-4.73,10.56-10.56,10.56h-20.06c-5.83,0-10.56-4.73-10.56-10.56V22.17c0-5.83,4.73-10.56,10.56-10.56Z"/>
    <path class="cls-2" d="m58.29,80.2h-28.98c-4.32,0-7.83-3.51-7.83-7.83V17.71c0-4.32,3.51-7.83,7.83-7.83h34.52c1.26,0,2.29,1.03,2.29,2.29v60.2c0,4.32-3.51,7.83-7.83,7.83ZM29.31,13.35c-2.41,0-4.37,1.96-4.37,4.37v54.65c0,2.41,1.96,4.37,4.37,4.37h28.98c2.41,0,4.37-1.96,4.37-4.37V13.35H29.31Z"/>
  </g>
  <g>
    <path class="cls-1" d="m55.55,78.44c-2.86-.76-3.8-3.45-3.8-6.33v-5.7H17.12v5.7c0,3.5,3.1,6.36,6.88,6.36h30.82l.73-.03Z"/>
    <path class="cls-2" d="m54.82,80.2h-30.82c-4.75,0-8.61-3.63-8.61-8.09v-5.7c0-.96.78-1.73,1.73-1.73h34.64c.96,0,1.73.78,1.73,1.73v5.7c0,2.64.84,4.21,2.51,4.65.83.22,1.37,1.02,1.28,1.87-.1.85-.8,1.51-1.66,1.54l-.73.03s-.04,0-.06,0Zm-35.97-12.06v3.97c0,2.55,2.31,4.62,5.15,4.62h26.96c-.62-1.26-.94-2.81-.94-4.62v-3.97h-31.17Z"/>
  </g>
  <g>
    <path class="cls-3" d="m56.18,28.72h-24.77c-.64,0-1.16-.52-1.16-1.16s.52-1.16,1.16-1.16h24.77c.64,0,1.16.52,1.16,1.16s-.52,1.16-1.16,1.16Z"/>
    <path class="cls-3" d="m56.18,37.46h-24.77c-.64,0-1.16-.52-1.16-1.16s.52-1.16,1.16-1.16h24.77c.64,0,1.16.52,1.16,1.16s-.52,1.16-1.16,1.16Z"/>
    <path class="cls-3" d="m56.18,46.19h-24.77c-.64,0-1.16-.52-1.16-1.16s.52-1.16,1.16-1.16h24.77c.64,0,1.16.52,1.16,1.16s-.52,1.16-1.16,1.16Z"/>
    <path class="cls-3" d="m56.18,54.93h-24.77c-.64,0-1.16-.52-1.16-1.16s.52-1.16,1.16-1.16h24.77c.64,0,1.16.52,1.16,1.16s-.52,1.16-1.16,1.16Z"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "HistoricalSynopsisIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #115c72;
  }
  .cls-3 {
    fill: #59c5c7;
  }
</style>